<mat-toolbar class="new-request-toolbar">

    <div>
        <button mat-icon-button (click)="goBack()">
            <mat-icon>keyboard_arrow_left</mat-icon>
        </button>
        <div class="title">
            <mat-icon>{{GLOBAL.ICONS.NEWREQUEST}}</mat-icon>
            <ng-container *ngIf="new">New Request</ng-container>
            <ng-container *ngIf="!new">New {{item.values.data?.origin | param:"projectOrigins"}}
                {{item.values.data?.projectType | param:"projectTypes"}} Request</ng-container>
        </div>
    </div>
    <div>
        <profile></profile>
        <button mat-icon-button [matMenuTriggerFor]="menu">
            <mat-icon>more_vert</mat-icon>
        </button>
        <mat-menu #menu="matMenu">
            <button mat-menu-item (click)="changeRequestType()">
                <mat-icon>{{GLOBAL.ICONS.PROJECT}}</mat-icon>
                <span>Change Request Type</span>
            </button>
            <button mat-menu-item (click)="logs()">
                <mat-icon>{{GLOBAL.ICONS.LOGS}}</mat-icon>
                <span>Logs</span>
            </button>
        </mat-menu>
    </div>

</mat-toolbar>
<div class="toolbartop"></div>

<!------------------------------ STEPS  ----------------------------------------->

<div class="steps-header" *ngIf="!new">
    <div class="steps">
        <button mat-button class="step" (click)="setStep(1)" [disabled]="!isStepDone(1)"
            [ngClass]="{active: currentStep === 1, complete: isStepDone(1)}">
            <mat-icon class="step-check" *ngIf="isStepDone(1)">check_circle</mat-icon>
            1. New Request
        </button>
        <button mat-button class="step" (click)="setStep(2)" [disabled]="!isStepDone(2)"
            [ngClass]="{active: currentStep === 2, complete: isStepDone(2)}">
            <mat-icon class="step-check" *ngIf="isStepDone(2)">check_circle</mat-icon>
            2. Add Contact
        </button>
        <button mat-button class="step" (click)="setStep(3)" [disabled]="!isStepDone(3)"
            [ngClass]="{active: currentStep === 3, complete: isStepDone(3)}">
            <mat-icon class="step-check" *ngIf="isStepDone(3)">check_circle</mat-icon>
            3. Assign
        </button>
    </div>
</div>


<!------------------------------ CREATE NEW  ----------------------------------------->

<div class="mdc-layout-grid" *ngIf="new">
    <div class="mdc-layout-grid__inner">
        <div class="mdc-layout-grid__cell--span-8">
            <form-builder [item]="item" [values]="item.values" section="agencymain" [edit]="true"
                (touch)="newRequestModified()"></form-builder>
        </div>
        <div class="mdc-layout-grid__cell--span-4">
            <app-unit-card [values]="preview" [mandate]="true"></app-unit-card>
            <mat-card *ngIf="!preview && item.values.data?.ref">
                <mat-card-header>
                    <mat-card-title>Wrong Ref Number</mat-card-title>
                </mat-card-header>
                <mat-card-content>
                    <p>No mandate linked to this reference</p>
                </mat-card-content>
            </mat-card>
        </div>
    </div>
</div>



<!------------------------------ STEP 1  ----------------------------------------->

<div class="step-section" *ngIf="!new && currentStep === 1">
    <div class="mdc-layout-grid">
        <div class="mdc-layout-grid__inner">
            <div class="mdc-layout-grid__cell--span-4">
                <mat-card class="step-card">
                    <mat-card-header>
                        <mat-card-title>Step 1 - Request details</mat-card-title>
                    </mat-card-header>
                    <mat-card-content>
                        <p>Request details.</p>

                        <div *ngIf="hasMandateLink" style="margin-top:12px;">
                            <p><strong>Type:</strong> {{item.values?.type | param:'actionTypes'}}</p>
                            <p><strong>Project type:</strong> {{item.values?.data?.projectType | param:'projectTypes'}}</p>
                        </div>

                        <div *ngIf="!hasMandateLink" style="margin-top:12px;">
                            <p>Select request type and project type.</p>
                            <div class="step-actions" style="margin-bottom: 12px;">
                                <button mat-raised-button
                                    [color]="item.values?.type === 'newRequest' ? 'accent' : undefined"
                                    (click)="setRequestType('newRequest')">
                                    New Project Request
                                </button>
                                <button mat-raised-button
                                    [color]="item.values?.type === 'newMandate' ? 'accent' : undefined"
                                    (click)="setRequestType('newMandate')">
                                    New Mandate Request
                                </button>
                            </div>

                            <p>Confirm if the request is for buying or renting.</p>
                            <div class="step-actions">
                                <button mat-raised-button
                                    [color]="item.values?.data?.projectType === 'sale' ? 'primary' : undefined"
                                    (click)="setProjectType('sale')">
                                    Buy
                                </button>
                                <button mat-raised-button
                                    [color]="item.values?.data?.projectType === 'rental' ? 'primary' : undefined"
                                    (click)="setProjectType('rental')">
                                    Rent
                                </button>
                            </div>
                        </div>

                        <div class="step-actions" style="margin-top: 12px;">
                            <button mat-raised-button color="accent" (click)="setStep(2)" [disabled]="!canGoStep(2)">
                                Next: Add Contact
                            </button>
                        </div>
                    </mat-card-content>
                </mat-card>
            </div>
            <div class="mdc-layout-grid__cell--span-8">
                <mat-card class="step-card" *ngIf="item.values?.data?.msg" style="margin-bottom:12px;">
                    <mat-card-header>
                        <mat-card-title>Client message</mat-card-title>
                    </mat-card-header>
                    <mat-card-content>
                        {{item.values?.data?.msg}}
                    </mat-card-content>
                </mat-card>

                <div class="mdc-layout-grid" style="padding:0;">
                    <div class="mdc-layout-grid__inner">
                        <div class="mdc-layout-grid__cell--span-6">
                            <new-request-card [values]="item.values"></new-request-card>
                        </div>
                        <div class="mdc-layout-grid__cell--span-6">
                            <app-unit-card *ngIf="item.values.synaps?.mandatesActionsObj" [values]="item.list?.mandate" [mandate]="true"></app-unit-card>
                            <mat-card *ngIf="!item.values.synaps?.mandatesActionsObj">
                                <mat-card-header>
                                    <mat-card-title>No Mandate</mat-card-title>
                                </mat-card-header>
                                <mat-card-content>
                                    <p>No mandate linked to this request</p>
                                </mat-card-content>
                            </mat-card>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!------------------------------ STEP 2  ----------------------------------------->

<div class="step-section" *ngIf="!new && currentStep === 2">
    <div class="mdc-layout-grid">
        <div class="mdc-layout-grid__inner">
            <div class="mdc-layout-grid__cell--span-4">
                <mat-card class="step-card">
                    <mat-card-header>
                        <mat-card-title>Step 2 - Add the user to the database</mat-card-title>
                    </mat-card-header>
                    <mat-card-content>
                        <p>Select or create the contact for this request so we can match previous projects.</p>
                        <div class="step-actions">
                            <button mat-raised-button
                                [color]="item.values.synaps?.contactActionsObj?.$key ? 'primary' : 'accent'"
                                (click)="selectContact()">
                                Select Contact
                            </button>
                            <button mat-raised-button color="accent" (click)="setStep(3)"
                                [disabled]="!item.values.synaps?.contactActionsObj?.$key">
                                Next: Assign
                            </button>
                        </div>
                    </mat-card-content>
                </mat-card>
            </div>
            <div class="mdc-layout-grid__cell--span-8">
                <mat-card class="step-card" *ngIf="item.values.synaps?.contactActionsObj?.$key" style="margin-bottom:12px;">
                    <mat-card-content>
                        <mat-icon color="warn" style="vertical-align: middle; margin-right: 6px;">warning</mat-icon>
                        <strong>Important:</strong> Please make sure the selected contact has all the latest details from the request.
                    </mat-card-content>
                </mat-card>
                <div class="mdc-layout-grid" style="padding:0;">
                    <div class="mdc-layout-grid__inner">
                        <div class="mdc-layout-grid__cell--span-6">
                            <new-request-card [values]="item.values"></new-request-card>
                        </div>
                        <div class="mdc-layout-grid__cell--span-6">
                            <mat-card *ngIf="!item.values.synaps?.contactActionsObj">
                                <mat-card-header>
                                    <mat-card-title>No Contact</mat-card-title>
                                </mat-card-header>
                            </mat-card>
                            <app-contact-tab *ngIf="item.values.synaps?.contactActionsObj?.$key"
                                [key]="item.values.synaps?.contactActionsObj?.$key" [options]="{displayRef:true}">
                            </app-contact-tab>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!------------------------------ STEP 3  ----------------------------------------->

<div class="step-section" *ngIf="!new && currentStep === 3">
    <div class="mdc-layout-grid">
        <div class="mdc-layout-grid__inner">
            <div class="mdc-layout-grid__cell--span-4">
                <mat-card class="step-card">
                    <mat-card-header>
                        <mat-card-title>Step 3 - Assign</mat-card-title>
                    </mat-card-header>
                    <mat-card-content>
                        <p>Choose one of the three options to assign this request.</p>
                    </mat-card-content>
                </mat-card>
                <app-unit-card *ngIf="item.values.synaps?.mandatesActionsObj" [values]="item.list?.mandate" [mandate]="true"></app-unit-card>
                <mat-card *ngIf="!item.values.synaps?.mandatesActionsObj">
                    <mat-card-header>
                        <mat-card-title>No Mandate</mat-card-title>
                    </mat-card-header>
                    <mat-card-content>
                        <p>No mandate linked to this request</p>
                    </mat-card-content>
                </mat-card>
            </div>
            <div class="mdc-layout-grid__cell--span-8">
                <mat-card-title class="matching-projects-title" *ngIf="matchingProjects.length">
                    Select one of the active projects if any
                </mat-card-title>
                <table mat-table *ngIf="matchingProjects.length" [dataSource]="matchingProjects" class="mat-elevation-z8 matching-projects-table">

    <ng-container matColumnDef="icon">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let element">
            <mat-icon matListIcon [ngClass]="element.status">{{element.status | icon :'projectStatus'}}</mat-icon>
        </td>
    </ng-container>

    <ng-container matColumnDef="ref">
        <th mat-header-cell *matHeaderCellDef>Ref</th>
        <td mat-cell *matCellDef="let element"> C{{element.ref}} </td>
    </ng-container>

    <ng-container matColumnDef="type">
        <th mat-header-cell *matHeaderCellDef>Type</th>
        <td mat-cell *matCellDef="let element"> {{element.type | param:'projectTypes'}} </td>
    </ng-container>

    <ng-container matColumnDef="date">
        <th mat-header-cell *matHeaderCellDef>Date</th>
        <td mat-cell *matCellDef="let element">
            {{element.dateNeed?.toDate() | date:'dd MMM yyyy'}}
        </td>
    </ng-container>

    <ng-container matColumnDef="unitTypes">
        <th mat-header-cell *matHeaderCellDef>Unit Types</th>
        <td mat-cell *matCellDef="let element">
            <mat-icon *ngFor="let unitType of element.unitTypes">{{unitType | icon:'unitTypes'}}
            </mat-icon>
        </td>
    </ng-container>

    <ng-container matColumnDef="minBedrooms">
        <th mat-header-cell *matHeaderCellDef>Min Beds</th>
        <td mat-cell *matCellDef="let element">{{element.minBedrooms}}</td>
    </ng-container>

    <ng-container matColumnDef="budget">
        <th mat-header-cell *matHeaderCellDef>Budget</th>
        <td mat-cell *matCellDef="let element">{{element.maxBudget | number}} {{element.cyBudget | param:'cies'}}</td>
    </ng-container>



    <ng-container matColumnDef="realtor">
        <th mat-header-cell *matHeaderCellDef>Agent</th>
        <td mat-cell *matCellDef="let element">
            <img mat-card-avatar *ngIf="element.realtor" class="realtor" [src]="element.realtor | realtor"
                [matTooltip]="element.realtor | realtorTooltip" />
        </td>
    </ng-container>

    <ng-container matColumnDef="select">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let element">
            <button mat-icon-button color="primary"
                *ngIf="element.type === item.values.data?.projectType && element.status === 'failed'"
                (click)="projectSelect(element, true)">
                <mat-icon>refresh</mat-icon>
            </button>
            <button mat-icon-button color="accent"
                *ngIf="element.type === item.values.data?.projectType && (element.status === 'active' || element.status === 'new' || element.status === 'discovery')"
                (click)="projectSelect(element)">
                <mat-icon>check</mat-icon>
            </button>
        </td>
    </ng-container>

    <tr mat-header-row
        *matHeaderRowDef="['icon', 'date', 'ref', 'type', 'unitTypes', 'minBedrooms', 'budget', 'realtor', 'select']; sticky: true">
    </tr>
    <tr mat-row
        *matRowDef="let row; let element; columns: ['icon', 'date', 'ref', 'type', 'unitTypes', 'minBedrooms', 'budget', 'realtor', 'select'];">
    </tr>
                </table>

                <mat-card class="step-card" *ngIf="!matchingProjects.length && !projectLoading">
                    <mat-card-content>
                        <p>No previous active project found for this contact.</p>
                    </mat-card-content>
                </mat-card>

                <div class="or-divider">OR</div>

                <mat-card class="step-card">
                    <mat-card-header>
                        <mat-card-title>Lead Qualification</mat-card-title>
                    </mat-card-header>
                    <mat-card-content>
                        <div class="step-actions">
                            <button mat-raised-button color="primary" (click)="selectleadQualification()">
                                Assitant Lead Qualification
                            </button>
                        </div>
                    </mat-card-content>
                </mat-card>

                <div class="or-divider">OR</div>

                <mat-card class="step-card" *ngIf="availableAgents.length">
                    <mat-card-header>
                        <mat-card-title>Create a new Project for one of following Agents</mat-card-title>
                    </mat-card-header>
                    <mat-card-content>
                        <mat-list class="agent-list">
                            <mat-list-item *ngFor="let agent of availableAgents" class="agent-item">
                                <img matListAvatar [src]="agent.photo" />
                                <div mat-line>{{agent.name}}</div>
                                <button mat-icon-button color="accent" (click)="selectAgent(agent)" [disabled]="projectCreated">
                                    <mat-icon>check</mat-icon>
                                </button>
                            </mat-list-item>
                        </mat-list>
                    </mat-card-content>
                </mat-card>
            </div>
        </div>
    </div>

    <mat-spinner [strokeWidth]="5" [diameter]="50" *ngIf="projectLoading"></mat-spinner>
</div>

<mat-spinner [strokeWidth]="5" class="fixed" *ngIf="!(pageConfig.loaded || new)"></mat-spinner>


<!------------------------------ BUTTONS  ----------------------------------------->

<div class="toolbartop"></div>
<!-- NEW -->
<button *ngIf="new" mat-fab class="bottom-right pfixed"
    [disabled]="!item.valid || !item.modified || item.saving || (!preview && item.values.data?.ref)"
    (click)="saveNewItem()">
    <mat-icon matListIcon>check</mat-icon>
</button>
<ng-container *ngIf="!new">
    <!-- REMOVE NEW REQUEST-->
    <button *ngIf="isAdmin()" mat-fab class="bottom-left pfixed" color="basic" (click)="removeNewRequest()">
        <mat-icon matListIcon>delete</mat-icon>
    </button>
</ng-container>